React = require 'react/addons'
AgeProtectedRoute = require '../mixins/age-protected-route'
Router = require 'react-router'
{ State } = Router
VideoPlayer = require './shared/video-player'
VideoStore = require '../stores/video-store'
NavigationActions = require '../actions/navigation'
LightMode = require '../mixins/light-mode'

module.exports = React.createClass
  displayName: 'Video'

  mixins: [AgeProtectedRoute, Router.Navigation, State, LightMode]

  getInitialState: ->
    return {
      videoKeySuffix: 0
      videoIndex: 0
      continuousVideoIndex: 0
    }

  updateParamState: ->
    for vid, i in VideoStore.videos when vid.name is @getParams().videoId
      @setState { videoIndex: i, continuousVideoIndex: i }
      break

  componentWillReceiveProps: ->
    @updateParamState()

  componentWillMount: ->
    @updateParamState()

  componentDidMount: ->
    NavigationActions.hideNavigation()

  componentWillUnmount: ->
    NavigationActions.showNavigation()

  onPlayingNext: (newIndex) ->
    @setState { continuousVideoIndex: newIndex }

  onNext: ->
    nextIndex = @state.continuousVideoIndex + 1
    if nextIndex >= VideoStore.videos.length then nextIndex = 0

    video = VideoStore.videos[nextIndex]

    if nextIndex is @state.videoIndex
      @setState
        videoKeySuffix: @state.videoKeySuffix + 1
        continuousVideoIndex: @state.videoIndex
    else
      @transitionTo 'video', { videoId: video.name }

  onPrev: ->
    prevIndex = @state.continuousVideoIndex - 1
    if prevIndex < 0 then prevIndex = VideoStore.videos.length - 1

    video = VideoStore.videos[prevIndex]

    if prevIndex is @state.videoIndex
      @setState
        videoKeySuffix: @state.videoKeySuffix + 1
        continuousVideoIndex: @state.videoIndex
    else
      @transitionTo 'video', { videoId: video.name }

  onClose: -> @transitionTo 'home'

  render: ->
    video = VideoStore.videos[@state.videoIndex]
    playlist =
      videos: VideoStore.videos
      index: @state.videoIndex

    key = "#{video.key}-#{@state.videoKeySuffix}"

    React.createElement("div", {"className": 'video'},
      React.createElement(VideoPlayer, {"key": (key), "video": (video), "initialPlaylist": (playlist), "onPlayingNext": (@onPlayingNext), "onNext": (@onNext), "onPrev": (@onPrev), "onClose": (@onClose)})
    )



/** WEBPACK FOOTER **
 ** ./~/cjsx-loader!./src/scripts/components/video.cjsx
 **/